// Sanitisation for authored rich text.
//
// Card bodies are HTML produced by the admin RichTextEditor (TipTap) and stored
// in the database, then rendered into caregivers' browsers. Variable
// substitution is already escaped in `interpolate`, so the injection path there
// is closed — this covers the other half: the stored markup itself. An admin
// account is semi-trusted, not trusted, and this is a health app, so the markup
// gets an allowlist on the way to the DOM rather than a promise that authors
// behave.
//
// The allowlist matches what the editor can actually produce. Anything outside
// it (script, style, iframe, event handlers, javascript: URLs) is dropped —
// which means widening the editor's toolbar requires widening this list too.
import DOMPurify from 'dompurify';
/** Tags TipTap StarterKit + our custom marks can emit. */
const ALLOWED_TAGS = [
    'p', 'br', 'span', 'div',
    'strong', 'b', 'em', 'i', 'u', 's', 'mark', 'sub', 'sup',
    'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4',
    'blockquote', 'code', 'pre',
    'a',
    'hr',
];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'class'];
/**
 * Sanitise authored HTML for rendering.
 *
 * Safe to call on every render — DOMPurify is fast and the alternative
 * (sanitising at write time only) would leave already-stored content
 * unprotected.
 */
export function sanitizeRichText(html) {
    if (!html)
        return '';
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        // Block javascript:/data: URLs on links.
        ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
    });
}
